
import styles from './FileInput.module.scss'
import React, {ChangeEvent, useState} from "react";
import Button from "@/Atoms/Input/Button";
import RoundIcon from "@/Atoms/RoundIcon";
import IconCrossBlack from "@/Atoms/Icons/IconCross";


type FileInputType = {
  label?: any,
  className?: any,
  onChange?: (file?: File) => void,
  fileName?: string,
  innerRef?: any,
  showName?: boolean
  startIcon?: any
  endIcon?: any
  accept?: string
  isClearable?: boolean
  isLoading?: boolean
}

export default (props: FileInputType) =>
{
  const {
    showName,
    isLoading,
    label,
    innerRef,
    className,
    fileName,
    onChange,
    startIcon,
    endIcon,
    isClearable,
    ...restProps
  } = props
  const [selectedName, setSelectedName] = useState(fileName ?? '');
  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file: File = (event.target.files as FileList)[0];
    // const file = event.target.files[0];

    setSelectedName(file.name);
    onChange && onChange(file);
    // @ts-ignore
    event.target.value = null;
  };

  const handleClear = () => {

    setSelectedName('');
    onChange && onChange(undefined);
    // @ts-ignore
    if (innerRef) {
      innerRef.current.value = null
    }
  }

  return <div className={`${className ?? ''} ${styles.container}`}>
    <label className={styles.inputWrapper}>
      <input
        type={"file"}
        {...restProps}
        className={styles.input}
        onChange={handleFileChange}
        ref={innerRef}
        disabled={isLoading}
      />
      <Button disabled={isLoading} className={styles.button}>{startIcon}{isLoading ? 'Loading...' : label}</Button>
      {showName !== false && <div className={styles.filename}>{selectedName}</div> }
    </label>
    {isLoading && <RoundIcon
        dark
        rotating
        icon={<i className="fa-solid fa-spinner"></i>}/>}
    {!isLoading && isClearable === true && selectedName !== '' && <div className={styles.clear}>
        <RoundIcon
            dark
            icon={<IconCrossBlack
              onClick={handleClear}
            />
      } />
    </div> }
  </div>
}
